<template>
  <el-button
    size="small"
    :type="isUsedDialog ? 'info' : 'primary'"
    :plain="!isUsedDialog"
    icon="el-icon-bank-card"
    @click="read"
    :loading="loading"
  >
    {{ text }}
  </el-button>
</template>

<script>
// optimize by R0629
import api from './api';
export default {
  props: {
    isUsedDialog: { // 是否用于弹窗，是的话，emit错误，并且type="info"
      type: Boolean,
      default: true // 为兼容前者逻辑，默认true
    },
    text: {
      type: String,
      default: '身份证读卡'
    },
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async read () {
      try {
        this.$emit('loading');
        this.loading = true;
        this.$store.dispatch('sendCard', {
            message: this.$message,
            callback: () => {
              const { pOutInfo, signBuffInfo, certno, psn_name, birth } =
                this.$store.state.readCardRawData.pOutInfo;
                const emitPatient = {
                  id: '',
                  idNo: certno,
                  idType: "SF",
                  name: psn_name,
                  birthday: birth,
                };
                this.$emit("ok", emitPatient);
                this.loading = false;
            },
        });
      } catch (error) {
        if (this.isUsedDialog) {
          this.$emit("err", error);
        } else {
          let errMsg = error;
          if (errMsg.toString().indexOf('失败') !== -1) {
            errMsg = '请将身份证放置在读卡器上';
          } else if (errMsg.toString().indexOf('无法打开读卡器') !== -1) {
            errMsg = '请连接读卡器';
          }
          this.$message.error(errMsg);
        }
        this.loading = false;
      }
      setTimeout(() => {
        this.loading = false;
      }, 5000)
    }
  }
};
</script>
